export const convertToLocalDateTimeString = (dateToConvert) => {
    return new Date(dateToConvert+"Z").toLocaleString()
}
